import React, { useContext } from 'react';
import { combine } from '../../../../helpers/styles';
import * as styles from './resultItem.module.scss';
import Text from '../../../ui/text';
import Icon from '../../../ui/icon';
import Image from '../../../ui/image';
import Link from '../../../ui/link';
import { MicrocopyContext } from '../../../../context/microcopy.context';
import { getCopy } from '../../../../helpers/copy';

const ResultItem = ({
  rank,
  profileLogoUrl,
  profileName,
  countryName,
  points,
  slug,
  isNew,
  up,
  hideCountry,
  profileIsPublic,
}) => {
  const microcopy = useContext(MicrocopyContext);

  const withWrapper = (children) => {
    if (slug && profileIsPublic) {
      return (
        <Link link={{ linkToPage: slug }} useGatsbyLink={false}>
          {children}
        </Link>
      );
    } else {
      return children;
    }
  };

  return withWrapper(
    <div className={styles.resultItem}>
      <div className={styles.ranking}>
        <div
          className={combine(
            styles.rank,
            isNew && styles.isNew,
            up && styles.movesUp,
            rank === 1 && styles.gold,
            rank === 2 && styles.silver,
            rank === 3 && styles.bronze
          )}
        >
          <Text as="span">{rank}</Text>
        </div>

        {profileLogoUrl ? (
          <Image
            image={{ url: profileLogoUrl }}
            className={styles.logo}
            imgClassName={styles.image}
          />
        ) : (
          <div className={combine(styles.logo, styles.transparent)} />
        )}
      </div>
      <div className={styles.company}>
        <Text as="span" type="p1" variant="semibold">
          {profileName}
        </Text>
        {!hideCountry && (
          <Text as="span" type="p3" variant="light">
            {countryName?.toUpperCase()}
          </Text>
        )}
      </div>
      <div className={styles.points}>
        <Text as="span" type="p3">
          {points}
          <Text as="span" type="p3" className={styles.pts}>
            {` ${getCopy('results.ranking.pts', microcopy)}`}
          </Text>
        </Text>
        {slug && profileIsPublic && (
          <Icon name="arrow-right" size="2x" className={styles.arrow} />
        )}
      </div>
    </div>
  );
};

export default ResultItem;
